import { processData } from "@/data/content";

const Process = () => {
  const process = processData;

  return (
    <section id="process" className="py-16 md:py-24 px-4 bg-gradient-to-b from-violet-50/60 via-white to-orange-50/50" data-testid="process-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">How It <span className="text-gradient-fire">Works</span></h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">Simple, streamlined process to get your brand live</p>
        </div>
        
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {process.map((item, idx) => (
            <div key={idx} className="text-center" data-testid={`process-step-${idx}`}>
              <div className="w-16 h-16 bg-red-500 text-white rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-4 shadow-lg">
                {item.step}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-gray-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;